module.exports = __webpack_public_path__ + "static/media/ROJAS.ad476c53.png";